<!-- TODO USE https://primeng.dev/inputcolor instead of p-colorPicker with Version 22+ -->
<p-colorPicker
    [formControl]="formControl"
    [formlyAttributes]="field"
    [inline]="false"
    format="hex"
    [ngClass]="!selectedColor ? 'undef-color-colorpicker' : ''"
    inputId="color-picker-input"
    [hideTransitionOptions]="'0.5s'"
    [style]="colorPickerStyle"
>
</p-colorPicker>
